var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-list',[_c('v-list-item',[_c('v-list-item-content',[_c('div',{staticClass:"d-flex justify-center pa-5"},[_c('v-progress-circular',{attrs:{"indeterminate":"","size":"40","width":"3"}})],1)])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }